import { CreateEntryContainer } from 'modules/Entries';

type Props = {};

const CreateEntry = (props: Props) => {
  return <CreateEntryContainer />;
};

export default CreateEntry;
